import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SpotsListComponent } from './spots-list/spots-list.component';
import { DashboardComponent } from 'src/app/core/layouts/dashboard/dashboard.component';
import { SpotsListMapComponent } from './spots-list-map/spots-list-map.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    children: [
      {path: '', component: SpotsListComponent}
    ]
  },
  {
    path: 'map',
    component: DashboardComponent,
    children: [
      {path: '', component: SpotsListMapComponent}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SpotsRoutingModule { }
